import { classNames } from '~/utils/client/helpers'
import { ApiImage, type ApiImageSize, type ApiImageSet } from './ApiImage'

export type ProductImageContainerProps = {
  imageSet?: ApiImageSet
  minimumSize?: ApiImageSize
  alt: string
  height?: 'h-24' | 'h-32' | 'h-40' | string
  className?: string
}

export const ProductImageContainer = ({
  imageSet,
  minimumSize,
  alt,
  height = 'h-24',
  className,
}: ProductImageContainerProps) => {
  return (
    <div
      className={classNames(
        'flex-shrink-0 flex items-center border border-border-subtle bg-surface-inset rounded-lg p-2 w-fit',
        height,
        className
      )}
    >
      <ApiImage
        imageSet={imageSet}
        minimumSize={minimumSize}
        className="h-full w-auto rounded-lg"
        alt={alt}
      />
    </div>
  )
}
